import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../auth/auth-context";

type NavItem = { to: string; label: string };

const ITEMS: NavItem[] = [
  { to: "/", label: "Home" },
  { to: "/events", label: "Eventy" },
  { to: "/clubs", label: "Kluby" },
  { to: "/players", label: "Single" },
  { to: "/team-players", label: "Deble" },
  { to: "/tournaments", label: "Wyniki" },
];

const Navigation: React.FC = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { user, loading } = useAuth();

  const isActive = (path: string) => {
    if (path === "/") {
      return location.pathname === "/";
    }

    return location.pathname.startsWith(path);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="navigation">
      <div className="nav-header">
        <Link to="/" className="nav-brand" onClick={closeMobileMenu}>
          <span className="nav-brand-mark">▾▴</span>
          <span className="nav-brand-name">Badminton<span className="nav-brand-name-accent">Arbiter</span></span>
        </Link>
        <button
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen((open) => !open)}
          aria-label="Przełącz menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
      <ul
        className={`nav-links ${isMobileMenuOpen ? "mobile-menu-open" : ""}`}
      >
        {ITEMS.map((item) => (
          <li key={item.to}>
            <Link
              to={item.to}
              className={isActive(item.to) ? "active" : ""}
              onClick={closeMobileMenu}
            >
              {item.label}
            </Link>
          </li>
        ))}
        <li className="nav-spacer" aria-hidden="true" />
        {!loading && (
          user ? (
            <li>
              <Link
                to="/me"
                className={`nav-me ${isActive("/me") ? "active" : ""}`}
                onClick={closeMobileMenu}
              >
                <span className="nav-me__avatar" aria-hidden="true">
                  {(user.name ?? user.email).slice(0, 1).toUpperCase()}
                </span>
                <span className="nav-me__label">
                  {user.name ?? user.email.split("@")[0]}
                </span>
              </Link>
            </li>
          ) : (
            <li>
              <Link
                to="/login"
                className={`nav-login ${isActive("/login") ? "active" : ""}`}
                onClick={closeMobileMenu}
              >
                Zaloguj
              </Link>
            </li>
          )
        )}
      </ul>
    </nav>
  );
};

export default Navigation;
